module.exports = __webpack_public_path__ + "img/David_Brady@2x.14e74930.png";